/*
 *                                                     __----~~~~~~~~~~~------___
 *                                    .  .   ~~//====......          __--~ ~~
 *                    -.            \_|//     |||\\  ~~~~~~::::... /~
 *                 ___-==_       _-~o~  \/    |||  \\            _/~~-
 *         __---~~~.==~||\=_    -_--~/_-~|-   |\\   \\        _/~
 *     _-~~     .=~    |  \\-_    '-~7  /-   /  ||    \      /
 *   .~       .~       |   \\ -_    /  /-   /   ||      \   /
 *  /  ____  /         |     \\ ~-_/  /|- _/   .||       \ /
 *  |~~    ~~|--~~~~--_ \     ~==-/   | \~--===~~        .\
 *           '         ~-|      /|    |-~\~~       __--~~
 *                       |-~~-_/ |    |   ~\_   _-~            /\
 *                            /  \     \__   \/~                \__
 *                        _--~ _/ | .-~~____--~-/                  ~~==.
 *                       ((->/~   '.|||' -_|    ~~-/ ,              . _||
 *                                  -_     ~\      ~~---l__i__i__i--~~_/
 *                                  _-~-__   ~)  \--______________--~~
 *                                //.-~~~-~_--~- |-------~~~~~~~~
 *                                       //.-~~~--\
 *                       ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *                               神兽保佑            永无BUG
 * 
 * @Author: xupeng ‘18309854921@163.com’
 * @Date: 2024-08-24 14:22:58
 * @LastEditors: xupeng ‘18309854921@163.com’
 * @LastEditTime: 2024-09-03 09:18:28
 * @FilePath: \admin\src\api\public.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { request, download } from '@/utils/request'

// 登录
// export function login(data) {
//   return request('POST', '/oauth/token', data, false)
// }
// 登录
export function login(data) {
  return request('POST', '/admin/login', data, false)
}
// 登出
export function logout(data) {
  return request('POST', '/admin/logout', data, false)
}

// 背景管理
export function getLoginBackend(type) {
  return request('GET','/background/image/index?type='+type, {}, true)
}



// 导出
export function postExcel(data, name) {
  return download('GET', '/admin/ordersExcelExportController/downFile', data, name)
}

